/*
 * Copyright (c) 2017-2026 Brighter AI Technologies GmbH. All rights reserved.
 * Unauthorized use, copying, reproduction, or distribution of this file, via any medium,
 * is strictly prohibited.
 */

import {
  Edit,
  useLogout,
  SimpleForm,
  TextInput,
  regex,
  required,
  useAuthenticated,
  useDataProvider,
} from "react-admin";
import { Toolbar } from "./Toolbar";
import CardHeader from "@material-ui/core/CardHeader";
import Container from "@material-ui/core/Container";
import { React, useState } from "react";
import { Button, Card, makeStyles } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { userUpdatedAction } from "../../reducers/userProfileReducer";
import { ActionTypes, CustomNotification } from "../shared/CustomNotification";

const useStyles = makeStyles((theme) => ({
  button: {
    marginTop: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
}));

const validateName = [
  required(),
  regex(/^(\p{L}+((\s)|(\.\s))?)+$/u, "Must be a valid name"),
];

const validatePhone = [regex(/^[0-9]{0,15}$/, "Must be a valid phone number")];

export const ProfileSection = ({ staticContext, ...props }) => {
  const classes = useStyles();
  useAuthenticated();
  const logout = useLogout();
  const dispatch = useDispatch();
  const dataProvider = useDataProvider();

  const [isNotificationOpen, setNotificationOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  async function onAction(actionType) {
    if (actionType === ActionTypes.ACCEPTED) {
      setIsDeleting(true);
      await dataProvider.delete("users", { id: "me" });
      setIsDeleting(false);
      logout();
    }
    setNotificationOpen(false);
  }

  return (
    <>
      <Container style={{ margin: 0, padding: 0 }}>
        <Card>
          <CardHeader
            title="Account Details"
            action={
              process.env.REACT_APP_APP_ENV === "staging" ? (
                <Button
                  className={classes.button}
                  onClick={() => {
                    setNotificationOpen(true);
                  }}
                  variant="outlined"
                >
                  DELETE ACCOUNT
                </Button>
              ) : null
            }
          />
          <Edit
            key="user-data"
            mutationMode="pessimistic"
            id="me"
            resource="users/profile"
            basePath="/users/profile"
            title=" "
            onSuccess={(response) => dispatch(userUpdatedAction(response.data))}
            {...props}
          >
            <SimpleForm variant="outlined" toolbar={<Toolbar />}>
              <TextInput
                fullWidth={true}
                data-hj-suppress
                source="firstName"
                validate={validateName}
              />
              <TextInput
                fullWidth={true}
                data-hj-suppress
                source="lastName"
                validate={validateName}
              />
              <TextInput
                fullWidth={true}
                data-hj-suppress
                disabled
                source="email"
                validate={required()}
              />
              <TextInput fullWidth={true} data-hj-suppress source="company" />
              <TextInput fullWidth={true} data-hj-suppress source="jobTitle" />
              <TextInput fullWidth={true} data-hj-suppress source="country" />
              <TextInput
                fullWidth={true}
                data-hj-suppress
                source="phone"
                validate={validatePhone}
              />
            </SimpleForm>
          </Edit>
        </Card>
      </Container>
      <CustomNotification
        open={isNotificationOpen}
        onAction={onAction}
        headerText="WARNING"
        acceptButtonText="Delete account"
        declineButtonText="Cancel"
        bodyText="Are you sure you want to delete your account? This action can not be undone. After your account is deleted you will be logged out."
      />
      <CustomNotification
        open={isDeleting}
        headerText="Deleting account..."
        bodyText="Please wait a moment. It takes a while for your account to deleted."
      />
    </>
  );
};
